import {
  HttpContext,
  HttpContextToken,
  HttpErrorResponse
} from '@angular/common/http';

// Expected errors are still displayed, but do not become unhandled exceptions.
export const EXPECTED_HTTP_ERROR = new HttpContextToken<
  (error: HttpErrorResponse) => boolean
>(() => () => false);

// Let the request's caller handle these errors without a global error toast.
export const LOCALLY_HANDLED_HTTP_ERROR = new HttpContextToken<
  (error: HttpErrorResponse) => boolean
>(() => () => false);

// For sections that show their own inline error. A 401 still ends the session.
export function inlineErrorContext(): HttpContext {
  return new HttpContext().set(
    LOCALLY_HANDLED_HTTP_ERROR,
    (error) => error.status !== 401
  );
}
